<div *transloco="let t">
	@let subTitle = subTitleText();
	@if (consentMode) {
		<div mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="ml-4 mr-8 mt-1.5">
			<h2 class="text-xl font-semibold leading-8 tracking-tight">
				{{ t('policy.' + dialogPolicyNaming + '.title') }}
			</h2>
			<h3 class="min-h-[26px] text-lg font-medium leading-7">{{ subTitle }}</h3>
		</div>
		<div
			class="px-6 ml-4 mr-8"
			[innerHTML]="logoutMode ? t('policy.' + dialogPolicyNaming + '.infoTextLogout') : t('policy.' + dialogPolicyNaming + '.infoText')"></div>
	} @else {
		<ara-dialog-header [title]="t('policy.' + dialogPolicyNaming + '.title')" [subtitle]="subTitle" (closed)="decline()" />
	}
	<mat-dialog-content class="white-space-pre-wrap">
		@for (policy of policies; track policy.policyId) {
			<div class="my-6 mx-4">
				@if (policies.length > 1) {
					<h3 class="title px-1 text-lg font-medium leading-7 text-[color:var(--ara-ink)]">{{ t('policy.' + policy.type + '.name') }}</h3>
				}
				<div class="p-3 border-solid border rounded-lg border-[color:rgba(var(--ara-ink-rgb),0.24)]">
					<div [innerHTML]="sanitizeHtmlContent(policy?.htmlContent)" class="text-[color:rgba(var(--ara-ink-rgb),0.72)]"></div>
				</div>
			</div>
		}
	</mat-dialog-content>
	@if (consentMode) {
		<mat-dialog-actions class="flex flex-row items-center justify-between">
			<div class="flex flex-col items-start">
				@if (privacyPolicyHasCheckbox) {
					<mat-checkbox labelPosition="after" [(ngModel)]="privacyPolicyChecked">
						<mat-label>{{ t('policy.acknowledge') }}</mat-label>
					</mat-checkbox>
				}
				@if (termsOfServiceHasCheckbox) {
					<mat-checkbox labelPosition="after" [(ngModel)]="termsOfServiceChecked">
						<mat-label>{{ t('policy.accept') }}</mat-label>
					</mat-checkbox>
				}
			</div>
			<div class="flex flex-row items-end">
				@if (logoutMode) {
					<button type="button" (click)="decline()" class="m-2" araButton="stroked" color="warn" [attr.aria-label]="t('sideboard.logout')">
						<mat-icon>logout</mat-icon>
						@if (!isMobile) {
							<span>{{ t('sideboard.logout') }}</span>
						}
					</button>
				} @else {
					<button type="button" (click)="decline()" class="m-2" araButton="stroked" [attr.aria-label]="t('commonActions.cancel')">
						<mat-icon>cancel</mat-icon>
						@if (!isMobile) {
							<span>{{ t('commonActions.cancel') }}</span>
						}
					</button>
				}
				<button
					type="button"
					(click)="consent()"
					class="m-2"
					araButton="flat"
					color="primary"
					[attr.aria-label]="t('commonActions.continue')"
					[loading]="isSaving()"
					[disabled]="isSaving() || !(privacyPolicyChecked && termsOfServiceChecked)">
					<mat-icon>check</mat-icon>
					@if (!isMobile) {
						<span>
							{{ t('commonActions.continue') }}
						</span>
					}
				</button>
			</div>
		</mat-dialog-actions>
	}
</div>
